import { combineReducers } from "redux";
import loginReducer from "./Login/loginReducer";

export default combineReducers({
    loginReducer
});